import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';

const ItemContainer = styled.div`
    position:relative;
`;

const SubItemContainer = styled.ul`
    top: ${ props =>  ( props.mobile  ? `0rem` : `2.75rem`)}  ;
    width: max-content;
    min-width:100%;
    z-index:100;
    border: ${ props =>  ( props.mobile  ? `0px`: `1px solid ` + colors.blue1) };
    border-top: 0px;
    background-color: ${  props =>  ( props.mobile ?  colors.blue3 : colors.grey3) };
    color: ${  props =>  ( props.mobile ?  colors.white : 'inherit') };
`;

export class MenuItems extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            key: null
        };
    }
    
    mouseEnter = (key) => {
        this.setState({
            key: key
        });
    }
    
    mouseLeave = (key) => {
        this.setState({
            key: null
        });
    }
    
    subItemContent = (key, show) => {
        if(this.props.menuList[key].children === undefined) return null;
        let linkColor = this.props.mobile ? 'white' : 'blue1';
        const SubItems = this.props.menuList[key].children.filter(function(item) {
            return !item.skip;
            }).map((item, key) =>
            <li className="mar-no" key={key}>
                <a className={ `inline-block width-100 white-hover bg-blue3-hover p-3 inline-block ${linkColor} `} href={item.url}>{item.label}</a>
            </li>
        );
        
        var containerClass = !this.props.mobile ? 'absolute left-0' : '';
        
        return <SubItemContainer mobile={this.props.mobile || this.props.tablet} colors={colors}  className={`bg-grey3 ${containerClass} ${show}`}>{SubItems}</SubItemContainer>;
    }
    
    toggle = (key) => {
        this.setState({
            key: key
        });
    }
    handleClick(e, key,item) {
        if (!item.children) {
            return true;
        }
        e.preventDefault();
        this.toggle(key);
        return false;
    }
    
    render(){
        var itemClass = this.props.mobile ? 'white block py-3' : 'blue3-hover blue1 px-1 py-2 my-1 mr-3 font-w600 ';
        const $parent = this;
        
        const ListItems = this.props.menuList.filter(function(item) {
            return !item.skip;
            }).map(function(item,key) {
                return (
                    <ItemContainer key={key} onMouseEnter={(event) => $parent.mouseEnter(key)} onMouseLeave={(event) => $parent.mouseLeave(key)}>
                        { item.url ?
                        <a className={"inline-block ucfirst pointer " + itemClass} href={item.url} onClick={(e) => $parent.handleClick(e, key, item)}>{item.label} {item.children ? <div className="select inline-block pl-2 pr-3">&nbsp;</div>:''}</a>
                        :
                        <div className={"inline-block ucfirst pointer " + itemClass}  onClick={(e) => $parent.handleClick(e, key, item)}>{item.label} {item.children ? <div className="select inline-block pl-2 pr-3">&nbsp;</div>:''}</div>
                        }
                        {$parent.subItemContent(key, $parent.state.key === key ? '' : 'hide' )}
                    </ItemContainer>
                ); 
            });
        
        return ListItems;
    }
}